module.exports = __webpack_public_path__ + "img/home.03ffd0d5.png";